<div class="postbox" #postboxVar>
  <div class="body">
    <div class="header">{{ headerText }}</div>
    <div class="modes" *ngIf="type != 'reply'">
      <div class="mode" [ngStyle]="{'width':'50%'}" (click)="changeMode('post')">
          <i class="fas fa-edit" style="margin-right:5px;"></i> Post
      </div>
      <div class="mode"  [ngStyle]="{'width':'50%'}" (click)="changeMode('poll')">
          <i class="fas fa-chart-bar" style="margin-right:5px;"></i> Poll
      </div>
      <!--div class="mode" [ngStyle]="{'width':type == 'reply'?'50%':'33%'}" (click)="mode = 'gif'">
          <i class="zmdi zmdi-gif" style="border-radius:2px;padding:0 3px;border:2px solid rgb(5, 5, 200);margin-right:5px;"></i> GIF
      </div-->
    </div>
    <div class="replyTo" *ngIf="post != null && type == 'reply'">
      <div class="body">
        <span [innerHTML]="(post.detail.length > 60)?post.detail.substr(0,60)+'...':post.detail"></span>
        <div class="replyToFooter">{{ (post.feed_type == 'league_news')?'News Report':post.drafters_id }}</div>
      </div>
    </div>
    <div class="regular" *ngIf="mode == 'post'">
      <mat-form-field class="form">
          <div class="emoji-container" style="float: left;width: 100%;">
            <textarea matInput [placeholder]="(userId != 253)  ? ((type === 'reply' ? 'Your Comment' : 'Submit a post for admin approval...')) : 'Your ' + (type === 'reply' ? 'Comment' : 'Post')" [(ngModel)]="detail" (click)="isEmojiPickerVisible = false;" style="resize: none; overflow: hidden; font-size: 15px;" (keyup)="autoGrowTextZone($event)" #postboxInput></textarea>
          </div>
          <div class="post-icons" style="float: right;">
            <i class="fal fa-smile" (click)="isEmojiPickerVisible = !isEmojiPickerVisible;"></i>
            <i class="zmdi zmdi-gif" (click)="isEmojiPickerVisible = false; isGifPickerVisible = !isGifPickerVisible;" style="border-radius: 5px;padding: 0 3px;border: 2px solid #0f54eb;cursor: pointer;font-size: 20px;float: right;font-weight: 300;"></i>  
          </div>
      </mat-form-field>
    </div>
    <div class="poll" *ngIf="mode == 'poll'">
      <mat-form-field class="form">
        <input matInput placeholder="Poll Question" [(ngModel)]="poll.question" #postpollInput>
      </mat-form-field>
      <div class="option" *ngFor="let option of poll.options;let i = index;trackBy:trackOptions">
        <mat-form-field>
        <input matInput [placeholder]="'Option '+(i+1)" [(ngModel)]="poll.options[i]">
        </mat-form-field>
        <div class="delete" *ngIf="i > 1" (click)="deleteOption(i)"><i class="fas fa-trash-alt"></i></div>
      </div>
      <button mat-button class="add" [disabled]="poll.options.length >= 20" (click)="poll.options.push('')">Add Option</button>
      <div style="clear: both"> </div>
    </div>
    <emoji-mart class="emoji-mart" *ngIf="isEmojiPickerVisible" (emojiSelect)="addEmoji($event)" title="Choose your emoji" [style]="{ 'width': '390px', 'height':'270px', 'border':'none'}" set="emojione" isNative="true" sheetSize="16" emojiSize="18" ></emoji-mart>
    <div class="gif" *ngIf="isGifPickerVisible || gif != null">
      <app-giphy (setGIF)="catchGIF($event)"></app-giphy>
    </div>
    <div class="error" *ngIf="errorVisible">{{errorMessage}}</div>
    <div class="buttons">
      <ng-container *ngIf="user?.role_id == 1">
        <mat-checkbox [(ngModel)]="push_notification" style="margin-right:10px;">Push
          Notifications</mat-checkbox>
      </ng-container>
      <button mat-button class="cancel" (click)="emitClose()">Cancel</button>
      <button mat-button class="submit" (click)="save()" [disabled]="saving || (mode == 'gif' && gif == null)">Post</button>
    </div>
  </div>
</div>